import styled from "styled-components";

const C = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default C;
